// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8030bc8a","741":"fd22b6aa","787":"ca3b05bb"}[chunkId] + ".chunk.js";
};